import type * as React from "react";
import { icons } from "./icon-data.js";
import type { IconName } from "./icon-data.js";

export type { IconName };

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number | string;
}

/** Wanted Design System icon — single-color glyph, recolor via CSS `color`. */
export function Icon({ name, size, ...rest }: IconProps) {
  const d = icons[name];
  if (!d) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox={d.viewBox}
      fill="none"
      // ponytail: body strings are emitter-controlled <path> markup shipped by
      // the design system bundle (geometry + numeric fills/transforms only,
      // no user input reaches this) — dangerouslySetInnerHTML is how the
      // upstream Icon component renders glyphs, kept as-is on port.
      // biome-ignore lint/security/noDangerouslySetInnerHtml: trusted DS glyph data, see above
      dangerouslySetInnerHTML={{ __html: d.body }}
      {...rest}
    />
  );
}

export default Icon;
